__turbopack_context__.v({
  "wrapper": "pmTt2G_wrapper",
  "wrapper__label": "pmTt2G_wrapper__label",
  "wrapper__link-skeleton": "pmTt2G_wrapper__link-skeleton",
  "wrapper__links": "pmTt2G_wrapper__links",
});
